function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z",
  fill: "#201D1A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M8.183 17.813c.376.017.718-.222.834-.608l1.43-4.74.491-1.632.198 1.599.842 6.801c.054.434.39.76.793.767h.014c.397 0 .735-.31.802-.736l1.07-6.812c.146.275.415.449.707.449h4.822c.45 0 .814-.398.814-.888s-.365-.887-.814-.887h-4.332l-.88-1.799c-.16-.335-.496-.523-.847-.46-.343.06-.614.352-.673.725l-.433 2.752-.142.903-.11-.89-.693-5.59c-.05-.409-.355-.725-.732-.763-.383-.038-.73.214-.847.607l-1.79 5.934-.216.712-.11-.698-.403-2.574c-.06-.382-.341-.678-.694-.73-.35-.058-.695.152-.847.503l-.915 2.126H3.814c-.45 0-.814.397-.814.886 0 .49.365.888.814.888h2.23c.315 0 .603-.199.736-.51l.033-.074.629 4.004c.062.401.369.705.74.735z"
});

var SvgProject = function SvgProject(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProject, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/project.40b23f4e.svg";
export { ForwardRef as ReactComponent };